module.exports = __webpack_public_path__ + "static/img/spB_4.15126a4.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character2/spB_4.png
// module id = 1275
// module chunks = 1